import { render, staticRenderFns } from "./BrowseToFileModal.vue?vue&type=template&id=45d75cd2&scoped=true"
import script from "./BrowseToFileModal.vue?vue&type=script&lang=ts"
export * from "./BrowseToFileModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d75cd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d75cd2')) {
      api.createRecord('45d75cd2', component.options)
    } else {
      api.reload('45d75cd2', component.options)
    }
    module.hot.accept("./BrowseToFileModal.vue?vue&type=template&id=45d75cd2&scoped=true", function () {
      api.rerender('45d75cd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/BrowseToFileModal.vue"
export default component.exports